module.exports = __webpack_public_path__ + "img/health16_7-9-2021.c36228f7.jpg";